import { ApprovingInvoiceReports } from '@/features/approving_invoice_reports';

const ApprovingInvoiceReportsPage = () => {
  return <ApprovingInvoiceReports />;
};
export default ApprovingInvoiceReportsPage;
